import { Component, Input } from '@angular/core';
import { UnifiSnapshot } from '../version.service';

@Component({
  selector: 'app-netzwerk',
  templateUrl: './netzwerk.component.html',
})
export class NetzwerkComponent {
  @Input() unifi:         UnifiSnapshot | null = null;
  @Input() unifiTimedOut  = false;
  @Input() darkMode       = false;

  fmtBps(bps: number): string {
    if (bps >= 1_000_000) return (bps / 1_000_000).toFixed(1) + ' MB/s';
    if (bps >= 1_000)     return (bps / 1_000).toFixed(0) + ' KB/s';
    return bps.toFixed(0) + ' B/s';
  }

  fmtBytes(bytes: number): string {
    if (bytes >= 1_073_741_824) return (bytes / 1_073_741_824).toFixed(1) + ' GB';
    if (bytes >= 1_048_576)     return (bytes / 1_048_576).toFixed(0) + ' MB';
    if (bytes >= 1_024)         return (bytes / 1_024).toFixed(0) + ' KB';
    return bytes + ' B';
  }

  fmtUptime(seconds: number): string {
    if (seconds <= 0) return '–';
    const d = Math.floor(seconds / 86400);
    const h = Math.floor((seconds % 86400) / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    if (d > 0) return `${d}d ${h}h`;
    if (h > 0) return `${h}h ${m}m`;
    return `${m}m`;
  }

  deviceImg(shortname: string): string {
    return `assets/unifi/${shortname}.png`;
  }

  deviceIcon(type: string): string {
    if (type === 'uap') return '📶';
    if (type === 'usw') return '🔀';
    return '🌐';
  }

  get unifiDevicesSorted() {
    if (!this.unifi) return [];
    const order = (t: string) => t === 'ugw' ? 0 : t === 'usw' ? 1 : t === 'uap' ? 2 : 3;
    return [...this.unifi.devices].sort((a, b) => {
      const to = order(a.type) - order(b.type);
      return to !== 0 ? to : b.name.localeCompare(a.name);
    });
  }

  deviceLabel(type: string): string {
    if (type === 'uap') return 'Access Point';
    if (type === 'usw') return 'Switch';
    if (type === 'ugw') return 'Gateway';
    if (type === 'udm') return 'Dream Machine';
    if (type === 'uxg') return 'Gateway Pro';
    return type;
  }

  signalClass(dBm: number): string {
    if (dBm >= -55) return 'text-success';
    if (dBm >= -70) return 'text-warning';
    return 'text-danger';
  }

  signalLabel(dBm: number): string {
    if (dBm >= -55) return 'stark';
    if (dBm >= -70) return 'mittel';
    return 'schwach';
  }
}
